// import node module libraries
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, ListGroup, Card } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// import MDI icons
import Icon from '@mdi/react';
import { mdiArrowRight, mdiArrowLeft } from '@mdi/js';

// import custom components
import GKBreadcrumb from 'components/marketing/common/breadcrumb/GKBreadcrumb';

const HelpCenterGuideSingle = () => {
	const { t } = useTranslation();
	const guideInfo = useParams();
	const categoryslug = guideInfo.categoryslug;
	const articleslug = guideInfo.articleslug;
	const articleid = new URLSearchParams(window.location.search).get('id');

	const [GuideResource, setGuideResource] = useState([]);
	const [isLoadingGuideResource, setIsLoadingGuideResource] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoadingGuideResource(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/guides/${articleid}`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setGuideResource(
					responseData
				);
				setIsLoadingGuideResource(false);
			})
			.catch((error) => {
				setIsLoadingGuideResource(false);
			});
	}

	useEffect(() => {
		getData();
	}, [articleid]);

	return (
		<Fragment>
		{isLoadingGuideResource ? (
				<>
					<Fragment>
						<Fragment>
							<section className="pt-3">
								<Container>
									<Row>
										{/* breadcrumb */}
										<Col md={{ offset: 2, span: 8 }} xs={12}>
											<div>
												<Skeleton />
											</div>
										</Col>
									</Row>
								</Container>
							</section>

							{/* article content */}
							<section className="py-10">
								<Container>
									<Row>
										<Col md={{ offset: 2, span: 8 }} xs={12}>
											<div className="mb-8">
												<h1 className="display-4 fw-semi-bold">
													<Skeleton height="40px" />
												</h1>
												<Skeleton count={2} height="20px" />
												<h2 className="mt-6">
													<Skeleton height="30px" />
												</h2>
												<Skeleton count={10} />
												<p className="my-4">
													<Skeleton height="500px" />
												</p>
											</div>
										</Col>
									</Row>
								</Container>
							</section>
						</Fragment>
						{/* related articles list */}
						<section className="pt-0 pb-10">
							<Container>
								<Row>
									<Col md={{ offset: 2, span: 8 }} xs={12}>
										<Card className="border">
											<Card.Body>
												<h3 className="mb-3 fw-semi-bold"><Skeleton height="20px" /></h3>
												<ListGroup
													as="ul"
													bsPrefix="list-unstyled"
													className="mb-0"
												>
													{Array.from({ length: 4 }).map((_, idx) => (
														<ListGroup.Item
																	as="li"
																	className="mb-2"
														>
														<Skeleton height="10px" count={1} />
														</ListGroup.Item>
													))}
												</ListGroup>
											</Card.Body>
										</Card>
									</Col>
								</Row>
							</Container>
						</section>
					</Fragment>
				</>

		) : (
			<>
				<Fragment key={GuideResource.id}>
					<section className="pt-3">
						<Container>
							<Row>
								{/* breadcrumb */}
								<Col md={{ offset: 2, span: 8 }} xs={12}>
									<div>
										<GKBreadcrumb
											breadcrumb={[
												{
													page: 'Help Center',
													link: '/marketing/help-center/'
												},
												{
													page: 'Guides & Resources',
													link: '/marketing/help-center/guide/'
												},
												{
													page: categoryslug,
													link: '/marketing/help-center/guide-single/' + categoryslug
												},
												{
													page: GuideResource.guide_title,
													link: '#'
												}
											]}
										/>
									</div>
								</Col>
							</Row>
						</Container>
					</section>
					{/* article content */}
					<section className="py-10">
						<Container>
							<Row>
								<Col md={{ offset: 2, span: 8 }} xs={12}>
									<div className="mb-8">
										<h1 className="display-4 fw-semi-bold">
											{GuideResource.guide_title}
										</h1>
										<div
											className="mt-3"
											dangerouslySetInnerHTML={{
												__html: GuideResource.guide_content
											}}
										></div>
										<br />
										<Link to={`/marketing/help-center/guide-single/${categoryslug}`} className="link-primary">
											<Icon path={mdiArrowLeft} size={0.6} /> {t('Back to all articles from this category')}
										</Link>
										<br />
										<div className="d-md-flex justify-content-between align-items-center">
											{/* last updated */}
											<div className="mb-2 mb-md-0">
												<p className="mb-0 fs-6">
													{t('Last updated')}: {(() => {
														const lastUpdate = new Date(GuideResource.guide_last_update);
														const now = new Date();
														const diffTime = Math.abs(now - lastUpdate);
														const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
														const diffMonths = Math.floor(diffDays / 30);

														if (diffDays === 0) {
															return t('Today');
														} else if (diffDays === 1) {
															return t('Yesterday');
														} else if (diffMonths > 0) {
															return `${diffMonths} ${t('months ago')}`;
														} else {
															return `${diffDays} ${t('days ago')}`;
														}
													})()}
												</p>
														
											</div>
											{/* was this article helpful?
											<div>
												<h5 className="mb-0">
													{t("Was this article helpful?")}
													<Link to="#" className="text-muted ms-2">
														<i className="fe fe-thumbs-up"></i>
													</Link>
													<Link to="#" className="text-muted ms-2">
														<i className="fe fe-thumbs-down"></i>
													</Link>
												</h5>
											</div>
											*/}
										</div>
									</div>
								</Col>
							</Row>
						</Container>
					</section>
					{/* related articles list */}
					<section className="pt-0 pb-10">
						<Container>
							<Row>
								<Col md={{ offset: 2, span: 8 }} xs={12}>
									<Card className="border">
										<Card.Body>
											<h3 className="mb-3 fw-semi-bold">{t("Releated articles")}</h3>
											<ListGroup
												as="ul"
												bsPrefix="list-unstyled"
												className="mb-0"
											>
												{(() => {
													const filteredGuides = (GuideResource.related_guides || []).filter(
														guide => guide.guide_category_slug !== 'draft'
													);
													if (filteredGuides.length === 0) {
														return (
															<ListGroup.Item as="li" className="mb-2" bsPrefix=" ">
																{t("No releated articles found")}
															</ListGroup.Item>
														);
													}
													return filteredGuides.map((guide, index) => (
														<ListGroup.Item
															as="li"
															className="mb-2"
															bsPrefix=" "
															key={index}
														>
															<Link
																to={`/marketing/help-center/guide-single/${guide.guide_category_slug}/${guide.guide_slug}?id=${guide.id}`}
																className="text-body"
															>
																<Icon
																	path={mdiArrowRight}
																	className="me-1 text-muted"
																	size={0.6}
																/>
																{guide.guide_title}
															</Link>
														</ListGroup.Item>
													));
												})()}
											</ListGroup>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</section>
				</Fragment>
			</>
		)}
		</Fragment>
	);
};
export default HelpCenterGuideSingle;
